import styled from '@emotion/styled'

import { breakpoint } from '../../__styling/style-functions'
import { calcRem } from '../../__styling/style-functions/calc-rem'
import { metrics } from '../../__styling/settings/metrics'
import { colors } from '../../__styling/settings/colors'

import { supports } from '../../__helpers/at-supports-helper'
import { ThemeMargins } from '../../__styling/settings/metrics'

export interface GridProps {
    hasBackgroundFill?: boolean
    verticalSpacing?: keyof ThemeMargins | undefined
    numberOfColumns: number
}

export const StyledCerberus = styled('div')<GridProps>(
    {
        margin: '0 auto',
        width: '100%',

        display: 'table', // Grid FallBack
        tableLayout: 'fixed', // Required for IE so content does not overflow
    },
    ({ theme, hasBackgroundFill, verticalSpacing }) => ({
        marginBottom:
            verticalSpacing && calcRem(theme.margins[verticalSpacing]),
        backgroundColor: hasBackgroundFill ? colors.white : 'transparent',
    }),
    ({ theme, numberOfColumns }) =>
        supports('display: grid', {
            display: 'grid', // Override display: table
            gridTemplateColumns: '1fr',
            gridGap: calcRem(theme.margins.gridGap),
            alignItems: 'stretch',
            tableLayout: 'auto',

            [breakpoint('sm')]: {
                gridTemplateColumns:
                    numberOfColumns === 4
                        ? '1fr 1fr'
                        : `repeat(${numberOfColumns}, minmax(0, 1fr))`,
            },

            [breakpoint('md')]: {
                // prettier-ignore
                gridTemplateColumns: `repeat(${numberOfColumns},minmax(0, 1fr))`
            },
        }),
)

export const StyledHeader = styled('div')({
    display: 'block',
    marginBottom: calcRem(metrics.perthnow.margins.lg),
})

export interface StyledGridItemProps {
    numberOfColumns: number
}

export const StyledGridItem = styled('div')<StyledGridItemProps>(
    {},
    ({ theme, numberOfColumns }) => ({
        verticalAlign: 'top',
        display: 'block',
        marginBottom: calcRem(theme.margins.gridGap),

        [breakpoint('sm')]: {
            display: 'table-cell',
            marginBottom: 0, //reset

            ':nth-child(-n+2)': {
                marginBottom:
                    numberOfColumns === 4 ? calcRem(theme.margins.gridGap) : 0,
            },

            [':nth-child(-n + ' + (numberOfColumns - 1) + ')']: {
                paddingRight: calcRem(theme.margins.gridGap),
            },
        },

        [breakpoint('md')]: {
            ':nth-child(-n+2)': {
                marginBottom: 0,
            },
        },
    }),
    ({ numberOfColumns }) =>
        // If we don't support grid for the wrapper container we also don't want any of this flexbox code as it conflicts with the table fallback
        supports('display: grid', {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-start',
            alignItems: 'stretch',
            verticalAlign: 'baseline', // reset
            marginBottom: 0, //we dont need this if using grid because we have grid gap

            [breakpoint('sm')]: {
                // Reset
                [':nth-child(-n + ' + (numberOfColumns - 1) + ')']: {
                    paddingRight: 0,
                },
            },
        }),
)
